/**
 * Helper to extract the Cabcharge verification token (the `id`) from the message the digital product activation iFrame posts to its parent window after verification succeeds.
 * The iFrame posts the token using the field `cabcharge-mfa-token`, e.g: { "cabcharge-mfa-token": "<guid>" }
 */

/** The field name the iFrame uses to post the verification token. */
export const CABCHARGE_MFA_TOKEN_FIELD = "cabcharge-mfa-token";

/**
 * Extract the verification token (`id`) from the message data posted by the iFrame.
 * Returns null when the data does not contain a valid token.
 */
export function GetVerificationTokenFromMessage(data: unknown): string | null {
    if (!data || typeof data !== "object") return null;

    const message = data as Record<string, unknown>;
    const token = message[CABCHARGE_MFA_TOKEN_FIELD];

    return typeof token === "string" && token.length > 0 ? token : null;
}